"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveOption = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var RemoveOption = function (_a) {
    var disable = _a.disable, handleOnClick = _a.handleOnClick;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)({
            "dropdown-item": true,
            "space-between": true,
            "permissions-dropdown__remove": true,
            "permissions-dropdown__remove--disable": disable,
        }), onClick: handleOnClick },
        react_1.default.createElement("span", { className: (0, classnames_1.default)({
                "dropdown-item__name": true,
                "dropdown-item__name--disable": disable,
            }) }, "Remove"),
        react_1.default.createElement(icons_1.Delete, { className: (0, classnames_1.default)({
                "permissions-dropdown__remove--disable-svg": disable,
            }) })));
};
exports.RemoveOption = RemoveOption;
